// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        dark: true,
        colors: {
          background: '#353641',
          primary: '#aacdd3',
          'on-secondary': '#aacdd3',
          secondary: '#367c82',
          active: '#367c82',
        }

      },
    },
  }
})